export default __webpack_public_path__ + "static/media/connect-tile.5b3ca648.svg";